/**
 * ShareTwitter
 */
import Config from "./Config";

class Twitter {
  static resetOptions(options) {
    Object.assign(Config, options);
  }

  static init(nodeId) {
    const _nodeId = nodeId ? nodeId : Config.nodeId;
    const _tmp = this.getButton();
    document.querySelector(_nodeId).insertAdjacentHTML("beforeend", _tmp);
    this.addEvent();
  }

  static getButton() {
    const _tmp = `<button data-share="twitter" class="btn__share--twitter">
        <i class="icon__twitter"></i>
        <span>twitter</span>
    </button>`;

    return _tmp;
  }

  static share(options) {
    const _location =
      options && options.location
        ? options.location
        : Config && Config.location
          ? Config.location
          : window.location.href;
    const _title =
      options && options.title
        ? options.title
        : Config && Config.title
          ? Config.title
          : "";

    window.open(
      "https://twitter.com/intent/tweet?url=" + encodeURIComponent(_location) +
        "&text=" + encodeURIComponent(_title),
      "twitter"
    );
  }

  static addEvent() {
    document
      .querySelector("[data-share=twitter]")
      .addEventListener("click", () => {
        this.share();
      });
  }
}

export default Twitter;
